export default {
  mutations: {
    SET_PAYMENT_METHODS_LIST: 'SET_PAYMENT_METHODS_LIST',
  },
  getters: {
    GET_PAYMENT_METHODS_LIST: 'GET_PAYMENT_METHODS_LIST',
  },
  actions: {
    PAYMENT_METHODS_LIST: 'PAYMENT_METHODS_LIST',
  },
};
